/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HomerunConnectionSecrets interface.
 */
export function instanceOfHomerunConnectionSecrets(value) {
    if (!('apiKey' in value) || value['apiKey'] === undefined)
        return false;
    return true;
}
export function HomerunConnectionSecretsFromJSON(json) {
    return HomerunConnectionSecretsFromJSONTyped(json, false);
}
export function HomerunConnectionSecretsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'apiKey': json['apiKey'],
    };
}
export function HomerunConnectionSecretsToJSON(json) {
    return HomerunConnectionSecretsToJSONTyped(json, false);
}
export function HomerunConnectionSecretsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'apiKey': value['apiKey'],
    };
}
